import React, { useEffect, useState } from 'react';
import { getTopCauseCodes } from '../../api/work-orderAPI';

const COLOR_PALETTE = [
  'bg-primary-main',
  'bg-success-main',
  'bg-warning-main',
  'bg-danger',
  'bg-info-main',
  'bg-indigo',
  'bg-secondary',
  'bg-dark',
  'bg-orange',
  'bg-pink'
];

const CauseCodeChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getTopCauseCodes();
      setData(result);
    };
    fetchData();
  }, []);

  const total = data.reduce((sum, item) => sum + Number(item.count), 0);

  return (
    <div className="col-xxl-4">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-3">
            <h6 className="fw-bold text-lg">Top Cause Codes</h6>
          </div>

          {data.map((item, index) => {
            const colorClass = COLOR_PALETTE[index % COLOR_PALETTE.length];
            const percentage = total > 0 ? Math.round((Number(item.count) / total) * 100) : 0;

            return (
              <div className="row align-items-center mb-3" key={index}>
                <div className="col-md-4 text-primary-light fw-medium">
                  {item.name}
                </div>
                <div className="col-md-8 d-flex align-items-center gap-2">
                  <div className="w-100">
                    <div
                      className="progress progress-sm rounded-pill"
                      role="progressbar"
                      aria-valuenow={percentage}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className={`progress-bar ${colorClass} rounded-pill`}
                        style={{ width: `${percentage}%` }}
                      />
                    </div>
                  </div>
                  <span className="text-secondary-light font-xs fw-semibold">{percentage}%</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CauseCodeChart;
